import { DatabaseRecord } from "../repos/table.repo";
import { ContractModel } from "./contracts/contract.model";

export interface WaterInvoiceRowModel extends DatabaseRecord {
    name: string;
    amount: number;
    displayOrder: number;
    waterInvoiceId?: string;
    price: number;
    waterFactoryId: string;
    total: number;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    status?: string;
}

export class WaterInvoiceRowModelFactory {
    static getEmpty(): WaterInvoiceRowModel {
        return {
            id: "",
            name: "",
            amount: 0,
            displayOrder: 0,
            waterInvoiceId: "",
            price: 0,
            waterFactoryId: "",
            total: 0
        };
    }
}
export interface WaterInvoiceModel extends DatabaseRecord {
    waterInvoiceRows: WaterInvoiceRowModel[];
    year: number;
    month: number;
    waterUserId: string;
    waterMeterNumber: number;
    waterMeterNumberLast: number;
    amount: number;
    useTotal: number;
    useDay: number;
    readDate: string;
    readDateLast: string;
    enviromentFee: number;
    vat: number;
    total: number;
    code: number;
    readerUserName: string;
    readerFullName: string;
    feeLadderId: string;
    codeString: string;
    waterFactoryId: string;
    approveStatus: string;
    paymentDate?: string;
    sendDate?: string;
    waterUser?: ContractModel;
    signedPdfPath?: string;
    exportEInvoiceStatus: string;
    bankTransactionId?: string;
    payBillInput?: string;
    payBillCreator?: string;
    discount?: number;
    supportCash: number;
    vatTotal: number;
    enviromentFeeTotal: number;
    totalText?: string;
    eInvoiceKey?: string;
    eInvoiceNo: string;
    unitTypeId: string;
    tollAreaId: string;
    paymentMethod: string;
    eInvoiceStatus: string;
    eInvoiceArisingDate: string;
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    status: string;
    debtCollector?: string;
    supportCashRate?: number;
    notificationMethod?: string;
    meterSetupDate?: string;
    gps?: string;
}

export class WaterInvoiceModelFactory {
    static getEmpty(): WaterInvoiceModel {
        return {
            id: "",
            waterInvoiceRows: [],
            year: 0,
            month: 0,
            waterUserId: "",
            waterMeterNumber: 0,
            waterMeterNumberLast: 0,
            amount: 0,
            useTotal: 0,
            useDay: 0,
            readDate: "",
            readDateLast: "",
            enviromentFee: 0,
            vat: 0,
            total: 0,
            code: 0,
            readerUserName: "",
            readerFullName: "",
            feeLadderId: "",
            codeString: "",
            waterFactoryId: "",
            approveStatus: "",
            exportEInvoiceStatus: "",
            supportCash: 0,
            vatTotal: 0,
            enviromentFeeTotal: 0,
            eInvoiceNo: "",
            unitTypeId: "",
            tollAreaId: "",
            paymentMethod: "",
            eInvoiceStatus: "",
            eInvoiceArisingDate: "",
            createdAt: "",
            status: ""
        };
    }
}

export interface SendSmsWaterInvoiceModel {
    Data: WaterInvoiceModel;
    TemplateId: string;
    SmsGateway:string;
}
export interface SendNotificationWaterInvoiceModel {
    Data: WaterInvoiceModel[];
}

export interface PaymentWithAccountantPayload {
    id?: string;
    paymentMethod?: string;
    information: string;
    total: number;
    actualReceivedDate?: string;
}

export interface ApproveByTollAreaPayload {
    tollAreaId: string,
    month: string,
    year: string,
    approveStatus: string
}


export interface WaterInvoiceSummaryModel {
    status: string;
    statusAmount: number;
    amount: number;
    useTotal: number;
    vatTotal: number;
    enviromentFeeTotal: number;
    total: number;
    discount: number;
    allTotal: number;
  }

export interface UpdateWaterInvoiceModel {
    id: string;
    approveStatus?: string;
    paymentDate?: string;
}
  